export default __webpack_public_path__ + "static/media/Curriculum Vitae.57f65c6f.pdf";